import { render, staticRenderFns } from "./creditAcountDetail.vue?vue&type=template&id=28f24d38&scoped=true&"
import script from "./creditAcountDetail.vue?vue&type=script&lang=js&"
export * from "./creditAcountDetail.vue?vue&type=script&lang=js&"
import style0 from "./creditAcountDetail.vue?vue&type=style&index=0&id=28f24d38&lang=less&scoped=true&"
import style1 from "./creditAcountDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f24d38",
  null
  
)

export default component.exports